//external
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
//internal
import Route from '../../routes/Route';
import Rtpi from './list';

export const FilterRtpi = createContext({});

export default function Routes() {
  const [filter, setFilter] = useState({
    search: "",
    branch: null,
    page: 1,
  });

  let location = useLocation();

  useEffect(() => {
    const split = location?.pathname.split('/');
    if (split[3] !== "rtpi") {
      setFilter({
        search: "",
        branch: null,
        page: 1,
      });
    }
  }, [location, setFilter]);

  return (
    <FilterRtpi.Provider value={{ filter, setFilter }}>
      <Route path="/premixlabel/rtpi/rtpi_print" exact component={Rtpi} isPrivate/>
    </FilterRtpi.Provider>
  )
}